// Code del servidor que bloqueó el código de descuento de la venta.
import { errorCodeOf } from './promotionErrorCopy';

export type DiscountCodeBlockCode = 'DISCOUNT_AFTER_QUOTE';

/** Bloqueo tras un error: con folio o cobro el código ya no se puede cambiar. */
export function nextDiscountCodeBlock(
    current: DiscountCodeBlockCode | null,
    error: unknown,
): DiscountCodeBlockCode | null {
    return errorCodeOf(error) === 'DISCOUNT_AFTER_QUOTE' ? 'DISCOUNT_AFTER_QUOTE' : current;
}
